import styles from './style.module.scss';

interface Props {
    stats: { title: string; count: number }[];
};

/** Strip of exam counters sitting under the profile header. */
function ExamStats({ stats }: Props) {
    return (
        <div className={styles.exams_data}>
            {stats.map(({ title, count }) => <div key={title} className={styles.exams_data_card}>
                <span className={styles.exams_data_card_title}>{title}</span>
                <span className={styles.exams_data_card_detail}><b>{count}</b> Exam taken</span>
            </div>)}
        </div>
    );
};

export default ExamStats;
